import { Component, Input } from '@angular/core';
import { HLong } from '@shared/src/datatypes/HLong';
import { ShipmentController } from '@shared/src/controllers/route/shipment/shipment.controller';
import { ShipmentCardInRouteDto } from '@shared/src/dtos/shipment/ShipmentCardInRouteDto';

@Component({
    selector: 'shared-active-slots-item-shipment',
    templateUrl: './shared.active.slots.item.shipment.html',
    styleUrls: ['./shared.active.slots.item.shipment.scss']
})
export class SharedActiveSlotsItemShipmentComponent {

    constructor(public shipmentController: ShipmentController) { }

    @Input() public readonly: boolean;

    public shipments: ShipmentCardInRouteDto[] = [];
    public selectedShipment: ShipmentCardInRouteDto;

    private _routeId: number;
    @Input()
    public set routeId(value: number) {
        if (this._routeId === value)
            return;
        this._routeId = value;
        this.loadShipments();
    }
    public get routeId(): number {
        return this._routeId;
    }

    loadShipments() {
        if (HLong.isNullOrNullLong(this._routeId)) {
            this.shipments = [];
            this.selectedShipment = null;
            return;
        }
        this.shipmentController.getShipmentsInRouteByRouteId(this._routeId).subscribe(data => {
            this.shipments = data ? data : [];
            if (this.selectedShipment != null)
                this.selectedShipment = this.shipments.find(s => s.shipmentId === this.selectedShipment.shipmentId) || null;
        });
    }

    selectShipment(shipment: ShipmentCardInRouteDto) {
        this.selectedShipment = shipment;
    }

    onRefreshShipment(value: boolean) {
        if (!value)
            return;
        this.loadShipments();
    }
}
